import { useTranslation } from 'react-i18next'
import { MaterialType } from '../../models/materials.models'
import { ItemType, SelectOption } from '../../models/props.models'
import { Box } from '@mui/material'
import ModalForm, { ModalFormProps } from '../common/ModalForm.common'
import { useEffect, useMemo, useState } from 'react'
import { CatalogsApi } from '../../api/catalogs.api'


interface ModalExportProps
  extends Omit<ModalFormProps, 'value' | 'items' | 'steps' | 'setValue' | 'tabs' | 'title'> {
  type: MaterialType
  showCerfa: boolean
  isInventoryCheck?: boolean
}

const ModalExport: React.FC<ModalExportProps> = (props) => {
  const { t } = useTranslation()

  const { type, showCerfa, isInventoryCheck,...formProps } = props
  const [value, setValue] = useState<Partial<CatalogsApi.CatalogExportType>>({})

  const types = useMemo(() => {
    if(isInventoryCheck) {
      return ['exportInventoryCheckResource', 'exportInventoryCheckWaste']
    }
    return type === MaterialType.need
      ? ['export']
      : ['export', 'counting', 'resource', ...(showCerfa ? ['cerfa', 'exportPem', 'exportD'] : [])]
  }, [type, showCerfa, isInventoryCheck])
  const formats = useMemo(() => {
     if (isInventoryCheck) {
      return ['xlsx', 'csv']
     }
    return value.type === 'export' || value.type === 'exportPem' || value.type === 'exportD'
      ? ['xlsx', 'csv']
      : ['xlsx', 'pdf']
  }, [value.type, isInventoryCheck])

  useEffect(() => {
    if (!formats.find((format) => value.format === format)) {
      setValue((val) => ({ ...val, format: undefined }))
    }
  }, [formats, value.format])

  return (
    <Box>
      <ModalForm
        {...formProps}
        value={value}
        setValue={setValue}
        maxWidth="sm"
        title={t(`global:actions.export`)}
        submitLabel={t(`global:actions.download`)}
        items={[
          {
            type: ItemType.select,
            key: 'type',
            required: true,
            grid: { xs: 6 },
            props: {
              items: types.map<SelectOption>((value) => ({
                value,
                label: t(`materials:components.modalExport.types.${value}` as any),
                description: t(`materials:components.modalExport.types.${value}Description` as any, { defaultValue: '' }),
              })),
              label: t('materials:components.modalExport.type'),
              // Render only the main description 
              renderValue: (selected: string) => {
                return t(`materials:components.modalExport.types.${selected}` as any)
              },          
            } 
          },
          {
            type: ItemType.select,
            key: 'format',
            required: true,
            grid: { xs: 6 },
            props: {
              items: formats.map((value) => ({
                value,
                label: t(`materials:components.modalExport.formats.${value}` as any)
              })),
              label: t('materials:components.modalExport.format'),
            },
          },
        ]}
      />
    </Box>
  )
}
export default ModalExport
